// Client-side cookie utilities. Server-side (API route) cookies go through
// `apps/frontend/app/src/server/appendSetCookie.ts` — this module is for browser-only contexts
// where `document.cookie` is the appropriate API.

export const setCookie = (name: string, value: string, maxAge: number) => {
  let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    cookie += '; Secure'
  }
  document.cookie = cookie
}

// Matches `name=value` at the start of the cookie string or after "; ".
// Captures everything up to the next ";" as the value.
export const getCookie = (name: string): string | null => {
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`))
  return match?.[1] ? decodeURIComponent(match[1]) : null
}

export const clearCookie = (name: string) => {
  document.cookie = `${name}=; path=/; max-age=0`
}
